module.exports = __webpack_public_path__ + "static/media/1.e62d2540.jpg";